module.exports = __webpack_public_path__ + "img/MemeETC (22).5ee861a6.jpeg";